<template>
    <div class="ticket-packages-filter-map">
        <div class="filter">
            <strong>{{ trans.filters.filter_by_type }}</strong>

            <ul>
                <li
                    v-for="type in filterOptions.types"
                    :key="type.value"
                    :class="[
                        type.value,
                        { active: filters.types.includes(type.value) }
                    ]"
                    @click="handleTypeClick(type.value)"
                >
                    {{ type.label }}
                </li>
            </ul>

            <button
                type="button"
                @click="handleClearFilters"
                v-if="
                    filters.locationAndSector.length > 0 ||
                        filters.types.length > 0
                "
            >
                <i class="fa fa-times" />
                {{ trans.filters.reset }}
            </button>
        </div>

        <figure class="map">
            <map-sambadrome
                :location="filters.types.join(',')"
                :locationAndSector="filters.locationAndSector.join(',')"
                orientation="vertical"
                :availables="availables"
                :highlighted-items="highlightedItems"
                @location-clicked="handleLocationClicked"
                clickable
            />
        </figure>
    </div>
</template>

<script>
export default {
    props: {
        filters: {
            type: Object,
            default: () => ({
                types: [],
                locationAndSector: []
            })
        },
        filterOptions: {
            type: Object,
            default: () => ({
                types: [],
                locationAndSector: []
            })
        },
        availables: {
            type: Array,
            default: () => []
        },
        highlightedItems: {
            type: Array,
            default: () => []
        },
        trans: {
            type: Object,
            required: true
        }
    },
    methods: {
        filterItemsAfterClick(items, value) {
            if (items.includes(value)) {
                const index = items.indexOf(value);
                items.splice(index, 1);
            } else {
                items.push(value);
            }

            return items;
        },
        handleLocationClicked(props) {
            const locationAndSector = this.filterItemsAfterClick(
                this.filters.locationAndSector,
                `${props.location}-${props.sector}`
            );

            this.$emit("filter-change", {
                ...this.filters,
                locationAndSector,
                types: []
            });
        },
        handleTypeClick(typeValue) {
            const types = this.filterItemsAfterClick(
                this.filters.types,
                typeValue
            );

            this.$emit("filter-change", {
                ...this.filters,
                locationAndSector: [],
                types
            });
        },
        handleClearFilters() {
            this.$emit("filter-change", {
                ...this.filters,
                locationAndSector: [],
                types: []
            });
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

.ticket-packages-filter-map {
    display: flex;
    gap: 16px;
    margin-top: 18px;
    position: sticky;
    top: 80px;
}

.filter {
    ul {
        margin: 16px 0 0;
        padding: 0;
        list-style: none;
    }

    li {
        display: flex;
        align-items: center;
        gap: 8px;
        border: 1px solid $color2-gray-light;
        color: $color2-text-secondary;
        padding: 10px 8px;
        border-radius: 8px;
        font-size: 12px;
        line-height: 1;
        cursor: pointer;

        &::before {
            content: "";
            display: block;
            width: 12px;
            height: 12px;
            background-color: $color2-gray-light;
            border-radius: 50%;
        }

        &:hover {
            background-color: $color2-gray-lightest;
        }

        &.active {
            background-color: #f9fafb;
            border-color: #8b5cf6;
            color: #8b5cf6;
        }

        & + li {
            margin-top: 8px;
        }

        &.grandstands::before {
            background-color: $color2-grandstands;
        }
        &.front-box::before {
            background-color: $color2-front-box;
        }
        &.covered-box::before {
            background-color: $color2-covered-box;
        }
        &.frisa-13-pack::before {
            background-color: $color2-frisa-13-pack;
        }
        &.folia-tropical::before {
            background-color: $color2-folia-tropical;
        }
        &.super-folia::before {
            background-color: $color2-super-folia;
        }
        &.camarote-maravilha::before {
            background-color: $color2-camarote-maravilha;
        }
        &.allocated-chairs::before {
            background-color: $color2-allocated-chairs;
        }
        &.camarote-verderosa::before {
            background-color: $color2-verderosa;
        }
        &.camarote-mar::before {
            background-color: $color2-camarote-mar;
        }
    }

    button {
        display: block;
        appearance: none;
        border: none;
        background: transparent;
        color: $color2-text-secondary;
        margin: 16px auto 0;
        font-size: 14px;
        cursor: pointer;
        outline: none;

        &:hover {
            color: $color2-primary;
        }
    }
}

.map {
    flex: 1;
    margin: 40px 0 0;
}
</style>
